'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$ChatStarted(id, unread, expiresAt) {
  this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_id = null;
  this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_unread = 0;
  this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_expiresAt = null;
  this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_id = id;
  this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_unread = unread;
  this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_expiresAt = expiresAt;
}
export { $c_Lapp_api_DrugRequestPharmacyState$ChatStarted as $c_Lapp_api_DrugRequestPharmacyState$ChatStarted };
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$ChatStarted;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$ChatStarted() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$ChatStarted as $h_Lapp_api_DrugRequestPharmacyState$ChatStarted };
$h_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype = $c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype;
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1625102886), true);
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestPharmacyState$ChatStarted)) {
    var x = this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_id;
    var x$2 = x$0.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_id;
    if ((((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)) && (this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_unread === x$0.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_unread))) {
      var x$3 = this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_expiresAt;
      var x$4 = x$0.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_expiresAt;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.productArity__I = (function() {
  return 3;
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.productPrefix__T = (function() {
  return "ChatStarted";
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_id;
      break;
    }
    case 1: {
      return this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_unread;
      break;
    }
    case 2: {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime(this.Lapp_api_DrugRequestPharmacyState$ChatStarted__f_expiresAt);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_api_DrugRequestPharmacyState$ChatStarted.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "unread";
      break;
    }
    case 2: {
      return "expiresAt";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_DrugRequestPharmacyState$ChatStarted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestPharmacyState$ChatStarted)));
}
export { $isArrayOf_Lapp_api_DrugRequestPharmacyState$ChatStarted as $isArrayOf_Lapp_api_DrugRequestPharmacyState$ChatStarted };
var $d_Lapp_api_DrugRequestPharmacyState$ChatStarted = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$ChatStarted, "app.api.DrugRequestPharmacyState$ChatStarted", ({
  Lapp_api_DrugRequestPharmacyState$ChatStarted: 1,
  Lapp_api_DrugRequestPharmacyState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$ChatStarted as $d_Lapp_api_DrugRequestPharmacyState$ChatStarted };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Chat-Started.js.map
